module.exports = __webpack_public_path__ + "img/electric_use_selected.09e215e9.svg";